import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { Checkbox } from '@domain-group/fe-blueprint-ui/form';
import * as styles from './agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AgentCard = _ref => {
  var _agency$images, _address$division, _address$state;
  var agencyProp = _ref.agency,
    agent = _ref.agent,
    checked = _ref.checked,
    onClick = _ref.onClick;
  var isAgency = agencyProp !== undefined;
  var agency = isAgency ? agencyProp : agent.agency;
  var address = agency.address;
  return /* eslint-disable-next-line jsx-a11y/no-static-element-interactions */___EmotionJSX("div", {
    css: styles.container,
    onClick: onClick,
    onKeyUp: onClick
  }, isAgency ? ___EmotionJSX("img", {
    css: styles.logo,
    src: (_agency$images = agency.images) === null || _agency$images === void 0 ? void 0 : _agency$images.tinyLogo,
    alt: ""
  }) : ___EmotionJSX("div", {
    css: styles.agent
  }, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    imageUrl: agent === null || agent === void 0 ? void 0 : agent.profilePhoto,
    size: "custom",
    colorScheme: "dark",
    shape: "circle",
    theme: "allhomes"
  }), ___EmotionJSX("div", {
    css: styles.nameTitle
  }, ___EmotionJSX("div", {
    css: styles.agentName
  }, agent === null || agent === void 0 ? void 0 : agent.name), ___EmotionJSX("div", {
    css: styles.jobTitle
  }, agent === null || agent === void 0 ? void 0 : agent.jobTitle))), ___EmotionJSX("div", {
    css: styles.bottom
  }, ___EmotionJSX(Checkbox, {
    css: styles.checkbox,
    checked: checked,
    onChange: onClick
  }), ___EmotionJSX("div", {
    css: styles.nameAddress
  }, ___EmotionJSX("div", {
    css: styles.agencyName
  }, agency.name), ___EmotionJSX("div", {
    css: styles.address
  }, address === null || address === void 0 ? void 0 : (_address$division = address.division) === null || _address$division === void 0 ? void 0 : _address$division.name, " ", address === null || address === void 0 ? void 0 : (_address$state = address.state) === null || _address$state === void 0 ? void 0 : _address$state.abbreviation, ' ', address === null || address === void 0 ? void 0 : address.postcode))));
};
AgentCard.propTypes = {
  agency: PropTypes.shape({
    images: PropTypes.shape({
      tinyLogo: PropTypes.string
    }),
    name: PropTypes.string,
    address: PropTypes.shape({
      division: PropTypes.shape({
        name: PropTypes.string
      }),
      state: PropTypes.shape({
        abbreviation: PropTypes.string
      }),
      postcode: PropTypes.string
    })
  }),
  agent: PropTypes.shape({
    agency: PropTypes.shape({}),
    profilePhoto: PropTypes.string,
    name: PropTypes.string,
    jobTitle: PropTypes.string
  }),
  checked: PropTypes.bool,
  onClick: PropTypes.func
};
AgentCard.defaultProps = {
  agency: undefined,
  agent: undefined,
  checked: true,
  onClick: () => {}
};
export default AgentCard;